export const controllPalletTranslationAR = {
  controllPallet: {
    "controllPallet_title": "قائمة شهادات المنصات",
    "controllPallet_newPallet": "منصة جديدة",
    "controllPallet_printSuccess": "تمت طباعة المنصة بنجاح",
    "controllPallet_printError": "خطأ في طباعة المنصة",
    "controllPallet_deleteSuccess": "تم حذف المنصة بنجاح",
    "controllPallet_deleteError": "لم يتم حذف المنصة",
    
    // From ControlPalletsTitle.jsx
    "controllPallet_update": "تحديث",
    "controllPallet_delete": "حذف",
    
    // From AddPalletDetailes.jsx
    "controllPallet_newPalletTitle": "منصة جديدة",
    "controllPallet_palletWithId": "منصة: {{id}}",
    "controllPallet_customerUpdated": "تم تحديث العميل بنجاح",
    "controllPallet_customerNotUpdated": "لم يتم تحديث العميل",
    "controllPallet_itemDeleted": "تم حذف العنصر بنجاح",
    "controllPallet_chooseCustomer": "اختر العميل",
    "controllPallet_finish": "إنهاء",
    "controllPallet_newProduct": "منتج جديد",
    "controllPallet_updateItem": "تحديث العنصر",
    "controllPallet_externalPalletNumber": "رقم المنصة الخارجية",
    "controllPallet_dividePallet": "تقسيم المنصة: {{palletNum}}",
    "controllPallet_dividePallet_notification_overflow": "عدد الأكياس للتقسيم أعلى من العدد الموجود"
  }
}; 